import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TimeTrackingService } from '../../../../../services/time-tracking-role/time-tracking.service';
import { StaffMemberByPIN, TimeTrackingRole } from '../../../../../models/time-tracking';
import { dateStringFromISO8601, timeStringFromISO8601 } from '../../../../../utils';
import { ApiService } from '../../../../../services/api/api.service';


@Component({
  selector: 'app-clock-in-out-modal',
  templateUrl: './clock-in-out-modal.component.html',
  styleUrls: ['./clock-in-out-modal.component.css']
})
export class ClockInOutModalComponent implements OnInit {

  public pinInput = '';
  public roleIdInput: number = null;

  public roles: TimeTrackingRole[];

  public staffMember: StaffMemberByPIN = null;

  public loadingRoles = false;
  public loadingStaffMember = false;
  public loadingClockInOut = false;

  public successMessage = '';

  public serverError: number = null;
  public staffMemberNotFound = false;
  public clockInOutErrorMessage = '';

  public dateStringFromISO8601 = dateStringFromISO8601;
  public timeStringFromISO8601 = timeStringFromISO8601;

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    private timeTrackingService: TimeTrackingService
  ) {
  }

  ngOnInit() {
    this.loadRoles();
  }

  public loadStaffMember() {
    this.loadingStaffMember = true;

    this.staffMemberNotFound = false;
    this.clockInOutErrorMessage = '';

    this.apiService
      .getStaffMemberByPin(this.pinInput)
      .then(response => {
        this.staffMember = response;
      })
      .catch(reason => {
        if (reason.status === 404) {
          this.staffMemberNotFound = true;
          this.pinInput = '';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingStaffMember = false; });
  }

  public onPinChange() {
    this.staffMember = null;
    this.staffMemberNotFound = false;
    this.clockInOutErrorMessage = '';
  }

  public canSubmitPin() {
    return (this.pinInput.length > 0) && !this.loadingStaffMember;
  }

  public canSubmitClockIn() {
    return (
      !this.loadingRoles &&
      (
        (this.roles.length === 0) ||
        (this.roleIdInput !== null)
      ) &&
      !this.loadingClockInOut
    );
  }

  public submitClockIn() {
    this.loadingClockInOut = true;

    this.timeTrackingService
      .clockIn(this.pinInput, this.roleIdInput)
      .then(response => {
        this.successMessage = 'Clock-in complete';
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.clockInOutErrorMessage = 'Error: ' + reason.error.error;
        } else if (reason.status === 404) {
          this.staffMemberNotFound = true;
          this.pinInput = '';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingClockInOut = false; });
  }

  public submitClockOut() {
    this.loadingClockInOut = true;

    this.clockInOutErrorMessage = '';

    this.timeTrackingService
      .clockOut(this.pinInput)
      .then(response => {
        this.successMessage = 'Clock-out complete';
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.clockInOutErrorMessage = 'Error: ' + reason.error.error;
        } else if (reason.status === 404) {
          this.staffMemberNotFound = true;
          this.pinInput = '';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingClockInOut = false; });
  }

  private loadRoles() {
    this.loadingRoles = true;

    this.clockInOutErrorMessage = '';

    this.timeTrackingService
      .getTimeTrackingRoles(1, 100)
      .then(response => {
        this.roles = response.results;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingRoles = false; });
  }

}
